import Vue from 'vue'
// import VueCarousel from 'vue-carousel'

// import vuescroll from "vue-scroll";
import App from './app'
import router from '@router'
import axios from 'axios'
import '@components/_globals'
import Vuelidate from 'vuelidate'
import VueAnalytics from 'vue-analytics'
import UUID from 'vue-uuid'
import initializeStore from '@state/store'
import { vuexOidcCreateRouterMiddleware } from 'vuex-oidc'
import PubNubVue from 'pubnub-vue'
import VueSwal from 'vue-swal'
import { env } from '@/env'
async function initializeApplication() {
  Vue.use(UUID)
  Vue.use(Vuelidate)
  Vue.use(VueSwal)

  // Vue.use(VueCarousel)

  // Store state initialization
  const store = await initializeStore()

  // Google Analytics Integration
  if (env.VUE_APP_BASE_URL === 'https://ep-sandoweb.buildinglink.com/') {
    console.log('url:', env.VUE_APP_BASE_URL)
    console.log('Working Production', env.VUE_APP_BASE_URL)
    Vue.use(VueAnalytics, {
      id: 'UA-167089209-1',
      router,
    })
  } else {
    console.log('Working Testing', env.VUE_APP_BASE_URL)
    Vue.use(VueAnalytics, {
      id: 'UA-XXXXXXXXX',
      router,
    })
  }

  // Vue.use(VueAnalytics, {
  //   id: 'UA-167089209-1',
  //   router,
  // })

  // Pubnub Integration
  Vue.use(PubNubVue, {
    subscribeKey: 'sub-c-1d4ee26a-092e-11eb-a684-166a9baec35a',
    publishKey: 'pub-c-ec4eff14-ce51-43a3-91d6-59c42f1ebdef',
  })
  // Vue.use(vuescroll);

  // Don't warn about using the dev version of Vue in development.
  Vue.config.productionTip = env.NODE_ENV === 'production'

  // If running inside Cypress...
  if (env.VUE_APP_TEST === 'e2e') {
    // Ensure tests fail when Vue emits an error.
    Vue.config.errorHandler = window.Cypress.cy.onUncaughtException
  }
  // Response interceptor to intercept the error 401
  axios.interceptors.response.use(
    (res) => {
      return res
    },
    (error) => {
      // Return any error which is not due to authentication back to the calling service
      if (error.response.status !== 401) {
        return new Promise((resolve, reject) => {
          reject(error)
        })
      } else {
        return new Promise((resolve, reject) => {
          var roleId = parseInt(localStorage.getItem('roleId'))
          // If role is Admin and Vendor then Refresh Token
          if (roleId === 11 || roleId === 18) {
            router.push({ name: 'unauthorized' })
          } else {
            reject(error)
          }
        })
      }
    }
  )
  // Request interceptor to add token
  axios.interceptors.request.use(
    (config) => {
      // const token = localStorageService.getAccessToken();
      const EAuth = localStorage.getItem('buildingLink.authToken')
      config.headers['Authorization'] = 'Bearer ' + EAuth
      config.headers[
        'Ocp-Apim-Subscription-Key'
      ] = `69d72345f0e54c198e9f6bfaef7836bc`

      return config
    },
    (error) => {
      return Promise.reject(error)
    }
  )

  // Vue instance creation
  const app = new Vue({
    router,
    store,
    // vuescroll,
    render: (h) => h(App),
  }).$mount('#app')
  // OpenId Oauth Middleware
  router.beforeEach(vuexOidcCreateRouterMiddleware(store, 'oidcStore'))
  // If running e2e tests...
  if (env.VUE_APP_TEST === 'e2e') {
    // Attach the app to the window, which can be useful
    // for manually setting state in Cypress commands
    // such as `cy.logIn()`.
    window.__app__ = app
  }
}

initializeApplication()
